import React, {useState, useEffect} from "react"
import {useNavigate} from "react-router-dom"
import {useLanguage} from "../../context/LanguageContext"
import "./HomePageCards.css"
import Header from "../Header"
import {Config} from "../../Config/config"

export default function HomePageCards() {
  const navigate = useNavigate()
  const {language} = useLanguage()
  const [subCategories, setSubCategories] = useState([])

  const fetchSubCategories = (langCode) => {
    fetch(
      `${Config.ApiBaseUrl}/subcat/?category__firm=2&is_active=true
      `,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${Config.Token}`,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        const filteredSubCategories = data
          .map((sub) => {
            let langData = sub.subcategorylang.find(
              (lang) => lang.language__code === langCode
            )

            if (!langData) {
              langData = sub.subcategorylang.find(
                (lang) => lang.language__code === "TR" // Default to Turkish
              )
            }

            return langData
              ? {
                  id: sub.id,
                  name: langData.name,
                  description: langData.description,
                  image:
                    sub.image ||
                    "https://via.placeholder.com/150x150.png?text=No+Image",
                  has_option: sub.has_option,
                }
              : null
          })
          .filter(Boolean)

        setSubCategories(filteredSubCategories)
      })
  }

  useEffect(() => {
    if (language) {
      fetchSubCategories(language)
    }
  }, [language])

  const handleCardClick = (card, cardName) => {
    navigate("/show-all-menu", {
      state: {
        cardName,
        subCategoryId: card.id,
        hasOption: card.has_option,
      },
    })
  }

  return (
    <>
      <Header />
      <div className="homepage-cards">
        {subCategories.length === 0 ? (
          <div>Loading...</div>
        ) : (
          subCategories.map((card) => (
            <div
              key={card.id}
              className="card"
              onClick={() => handleCardClick(card, card.name)}
            >
              <div
                className="card-content"
                style={{
                  backgroundImage: `url(${card.image})`,
                }}
              >
                <div className="overlay">
                  <div className="card-name">{card.name.toUpperCase()}</div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </>
  )
}
